import Prismic from '@prismicio/client';
import Vue from 'vue';
const apiEndpoint = 'https://website-b2c.prismic.io/api/v2';
const prismicBlogsKnn = Prismic.client(apiEndpoint);
Vue.prototype.$prismicBlogsKnn = prismicBlogsKnn;
